import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tx-narrow tx-center" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode($setup["Empty"], {
      icon: "alert",
      text: $setup.state.t('errors.not_found')
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", {
          href: $setup.link(''),
          "data-nav": "",
          class: "tx-btn tx-btn--primary"
        }, _toDisplayString($setup.state.t("nav.home")), 9 /* TEXT, PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["text"])
  ]))
}